import React,{Fragment} from "react";
import {translate} from 'react-i18next';
import { Card, Col, Icon, Row, Tooltip } from "antd";
import _ from "lodash";
import { getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import { GUTTER_MD, SPAN_FULL, MARGIN_SM } from "../../../styles/constants";
import {connect} from "react-redux";
import {compose} from "redux";

const mapStateToProps = state => ({
    upgradeReport: state.scenes.dataManager.upgradeDsd.upgradeReport,
  });

const getColSpan = upgradeReport =>
SPAN_FULL / _.keys(_.pickBy({...upgradeReport, deleted: undefined}, arr => arr && arr.length > 0)).length;

const ReportCards = ({ t, upgradeReport, type, name, message }) => {

    const iconType = (type) => {
        switch (type) {
            case "success":
                return(<Icon type="check-circle" theme="filled" style={{color: 'green'}}/>)
            case 'warning':
                return(<Icon type="exclamation-circle" theme="filled" style={{color: 'orange'}}/>)
            case 'error':
                return(<Icon type="close-circle" theme="filled" style={{color: 'red'}}/>)
            default:
            }
    }
    const translationMatch = (name) => {
        switch (name) {
            case "upgrade":
                return(t(`scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.updated.title`))
            case "reCreated":
                return(t(`scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.notUpdated.title`))
            case 'fail':
                return(t(`scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.deleted.title`))
            case 'notChanged':
                return(t(`scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.notChanged.title`))
            case 'categorizationFail':
                return(t(`scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.categorizationFail.title`))
            default:
            }
    }
return( 
    <Fragment>
        {
        upgradeReport && upgradeReport[name] && upgradeReport[name].length > 0 && (
            <Col span={getColSpan(upgradeReport)}>
            <Card
                type="inner"
                title={
                <Row type="flex" gutter={GUTTER_MD} justify="start">
                    <Col>
                        {iconType(type)}
                    </Col>
                    <Col>
                        {translationMatch(name)}
                    </Col>
                    {message ? (
                      <Col>
                        <Tooltip
                          title={message}>
                          <Icon type="info-circle" style={{ marginLeft: MARGIN_SM }} />
                        </Tooltip>
                      </Col>
                    )
                      : (null)}

                </Row>
                }
                bodyStyle={{
                height: 320,
                overflow: 'auto'
                }}
            >
                {
                upgradeReport[name].map(({id, agency, version}, index) =>
                    <Row key={index}>
                    {getStringFromArtefactTriplet({id, agencyID: agency, version})}
                    </Row>
                )
                }
            </Card>
            </Col>
        )
        }
    </Fragment>
)
}

export default compose(
    translate(),
    connect(mapStateToProps)
  )(ReportCards)